import React, { useEffect, useRef, useState } from "react";
import { FaTrash } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import BaseUrl from "../../base-api";
import Loader from "../Loader/Loader";
import { FaAngleLeft, FaAngleRight, FaPencil } from "react-icons/fa6";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
const Links = () => {
  const [images, setImages] = useState([]);
  const [locations, setLocations] = useState([]);
  const [newImage, setNewImage] = useState({
    location: "",
    designation: "",
    address: "",
    email: "",
    mobileNo: "",
    file: null,
    officeNo: "",
    name: "",
  });
  const fileInputRef = useRef(null);
  const token = sessionStorage.getItem("userToken");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [viewImages, setViewImages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentImages, setCurrentImages] = useState(null);
  // const [editTitle, setEditTitle] = useState("");
  //   const [currentEditId, setCurrentEditId] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const designation = [
    {
      name: "Director",
      value: "Director",
    },
    {
      name: "Managing Director",
      value: "Managing Director",
    },
  ];

  const fetchData = async () => {
    setSearchQuery("");
    setCurrentPage(1);
    const token = sessionStorage.getItem("userToken");
    if (!token) return navigate("/login");
    setLoading(true);
    try {
      const resLocation = await axios.get(`${BaseUrl}/api/master/officeType`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (resLocation.data.status === 200) {
        const locationTypes = resLocation.data.data.map((item) => item.type);
        setLocations(locationTypes);
      } else {
        toast.error("Failed to fetch locations.");
      }

      const res = await axios.post(
        `${BaseUrl}/api/salerate/getAll`,
        { location: "All" },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (res.data.status === 200 && Array.isArray(res.data.data)) {
        const processedImages = res.data.data.map((img) => ({
          id: img.key,
          location: img.location,
          imageUrl: img.file ? `data:image/png;base64,${img.file}` : "",
          name: img.name,
          designation: img.designation,
          officeNo: img.officeNo,
          mobileNo: img.mobileNo,
          email: img.email,
          address: img.address,
        }));

        setImages(processedImages);
        setTotalItems(res.data.data.length);
      } else {
        toast.error(res.data.message || "Failed to load images.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setViewImages(images.slice(0, itemsPerPage));
  }, [images]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    const startIndex = (pageNumber - 1) * itemsPerPage;
    const endIndex = pageNumber * itemsPerPage;
    setViewImages(images.slice(startIndex, endIndex));
  };

  const handleNextPage = () => {
    if (currentPage * itemsPerPage < totalItems) {
      handlePageChange(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        toast.error(
          "Invalid file type. Please upload an image in jpg, png or jpeg format"
        );
        fileInputRef.current.value = "";
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        toast.error("File size exceeds 1MB.");
        fileInputRef.current.value = "";
        return;
      }
      setNewImage({ ...newImage, file });
    }
  };

  const handleLocationChange = (e) => {
    setNewImage({ ...newImage, location: e.target.value });
  };
  const handledesigChange = (e) => {
    setNewImage({ ...newImage, designation: e.target.value });
  };
  const handleInputChange = (e) => {
    setNewImage({ ...newImage, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (
      !newImage.location ||
      !newImage.file ||
      !newImage.name ||
      !newImage.email ||
      !newImage.address ||
      !newImage.mobileNo ||
      !newImage.designation
    ) {
      toast.error("Please fill all required details.", {
        closeButton: "false",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", newImage.file);
    formData.append("location", newImage.location);
    formData.append("name", newImage.name);
    formData.append("email", newImage.email);
    formData.append("address", newImage.address);
    formData.append("mobileNo", newImage.mobileNo);
    formData.append("designation", newImage.designation);
    formData.append("officeNo", newImage.officeNo);
    setLoading(true);
    try {
      const res = await axios.post(`${BaseUrl}/api/director/create`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      });

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchData();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Error uploading the image.");
    } finally {
      setNewImage({
        location: "",
        designation: "",
        address: "",
        email: "",
        mobileNo: "",
        file: null,
        officeNo: "",
        name: "",
      });
      if (fileInputRef.current) fileInputRef.current.value = "";
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const toastId = toast.warn(
      <div
        style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}
      >
        <p>Are you sure you want to delete this image?</p>
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-danger btn-sm mx-2"
            onClick={() => confirmDelete(id, toastId)}
          >
            Yes
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,

        // style: { width: "400px", minHeight: "220px" },
        closeButton: false,
      }
    );
  };

  const confirmDelete = async (id, toastId) => {
    toast.dismiss(toastId);
    toast.loading("Deleting image...", { position: "top-center" });
    setLoading(true);
    try {
      const res = await axios.post(
        `${BaseUrl}/api/director/delete`,
        { key: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      toast.dismiss();
      if (res.data.status === 200) {
        toast.success(res.data.message, { position: "top-center" });

        fetchData();
      } else {
        toast.error(res.data.message, { position: "top-center" });
      }
    } catch (error) {
      toast.error("Error deleting image.", { position: "top-center" });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id) => {
    const notification = images.find((item) => item.id === id);
    setCurrentImages(notification);
    // setEditTitle(notification.title);
    // setCurrentEditId(id);
    setIsEditModalOpen(true);
  };

  useEffect(() => {
    return () => {
      images.forEach((img) => {
        if (img.imageUrl?.startsWith("blob:")) {
          URL.revokeObjectURL(img.imageUrl);
        }
      });
    };
  }, [images]);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filteredLinks = images.filter((link) =>
      link.location.toLowerCase().includes(query)
    );

    setTotalItems(filteredLinks.length);
    setCurrentPage(1);
    setViewImages(filteredLinks.slice(0, itemsPerPage));
  };

  const handleEditSave = async () => {
    if (!currentImages.location ||
      !currentImages.name ||
      !currentImages.email ||
      !currentImages.address ||
      !currentImages.mobileNo ||
      !currentImages.designation) {
      toast.error("Fill All required Fields.");
      return;
    }



    const token = sessionStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("key", currentImages.id);
    formData.append("location", currentImages.location);
    formData.append("name", currentImages.name);
    formData.append("email", currentImages.email);
    formData.append("address", currentImages.address);
    formData.append("mobileNo", currentImages.mobileNo);
    formData.append("designation", currentImages.designation);
    formData.append("officeNo", currentImages.officeNo);

    if (fileInputRef.current.files[0]) {
      const file = fileInputRef.current.files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];

      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload an image in jpg, png or jpeg format.");
        fileInputRef.current.value = ""; // Reset file input
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        toast.error("File size exceeds 1MB.");
        fileInputRef.current.value = "";
        return;
      }
      formData.append("multipart", file);
    } else {
      toast.error("File cannot be empty.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(
        `${BaseUrl}/api/director/update`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        }
      );

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchData();
        setIsEditModalOpen(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Error updating the Directory.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="home-dashboard">
          <div className="ticket-tab">
            <h3>Upload Sale Rates</h3>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">
                  Location
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <select
                  className="form-select"
                  value={newImage.location}
                  onChange={handleLocationChange}
                >
                  <option value="">Select Location</option>
                  {locations.map((loc, index) => (
                    <option key={index} value={loc}>
                      {loc}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Name of Crop
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={newImage.name}
                  onChange={handleInputChange}
                  placeholder="Enter Crop Name"
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Crop Variety
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="variety"
                  value={newImage.variety}
                  onChange={handleInputChange}
                  placeholder="Enter Crop Variety"
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Packaging Size
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="size"
                  value={newImage.size}
                  onChange={handleInputChange}
                  placeholder="Enter Packaging Size"
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Full Sale Rate
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="saleRate"
                  value={newImage.saleRate}
                  onChange={handleInputChange}
                  placeholder="Enter Full Sale Rate"
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Subsidy
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="subsidy"
                  value={newImage.subsidy}
                  onChange={handleInputChange}
                  placeholder="Enter Subsidy Amount"
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Subsidized sale rate to Farmer<span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  name="subSaleRate"
                  value={newImage.subSaleRate}
                  onChange={handleInputChange}
                  placeholder="Enter Subsidized sale rate"
                />
              </div>



              <div className="col-md-2 mt-2">
                <button
                  type="button"
                  className="btn btn-success mt-5"
                  onClick={handleSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
          {/* <hr style={{  height: "2px", backgroundColor: "green", margin:"4% 0"}} /> */}
          <div className="ticket-tab">
            <div className="row mb-4">
              <div className="col-6">
                <h3>Manage Sale Rates</h3>
              </div>

              <div className="col-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by location.."
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Location</th>
                    <th>Name of Crop</th>
                    <th>Crop Variety</th>
                    <th>Packaging Size</th>
                    <th>Full Sale Rate</th>
                    <th>Subsidy</th>
                    <th>sale rate</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {viewImages.length > 0 ? (
                    viewImages.map((img) => (
                      <tr key={img.id}>
                        <td>{img.location}</td>
                        <td>
                          {img.imageUrl ? (
                            <img
                              src={img.imageUrl}
                              alt={img.location}
                              width="200"
                              height="100"
                            />
                          ) : (
                            "No Image"
                          )}
                        </td>
                        <td>
                          {img.name} <br /> {img.address}
                        </td>
                        <td>{img.designation}</td>
                        <td>
                          {img.mobileNo} <br />
                          {img.contactNo}
                        </td>
                        <td></td>
                        <td></td>
                        <td>
                          <FaPencil
                            className="me-2"
                            style={{ cursor: "pointer", color: "orange" }}
                            onClick={() => handleEdit(img.id)}
                          />
                          <FaTrash
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() => handleDelete(img.id)}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        No Data Found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="row mt-4">
              <div className="col-5">
                Total : {viewImages.length} of {totalItems}
              </div>
              <div className="col-7 ">
                <div className="d-flex align-items-center">
                  <button
                    style={{ width: "8%", borderRadius: "50%" }}
                    className="btn btn-success"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    <FaAngleLeft />
                  </button>

                  <div className="mx-3 d-flex">
                    {Array.from({
                      length: Math.ceil(totalItems / itemsPerPage),
                    }).map((_, index) => {
                      const pageNum = index + 1;

                      if (
                        pageNum === currentPage ||
                        pageNum === currentPage - 1 ||
                        pageNum === currentPage + 1
                      ) {
                        return (
                          <button
                            key={pageNum}
                            className={`btn mx-1 ${currentPage === pageNum
                              ? "active btn-primary"
                              : "btn-light"
                              }`}
                            onClick={() => handlePageChange(pageNum)}
                          >
                            {pageNum}
                          </button>
                        );
                      }
                      return null;
                    })}
                  </div>

                  <button
                    style={{ width: "8%", borderRadius: "50%" }}
                    className="btn btn-success"
                    onClick={handleNextPage}
                    disabled={
                      currentPage >= Math.ceil(totalItems / itemsPerPage)
                    }
                  >
                    <FaAngleRight />
                  </button>
                </div>
              </div>
            </div>

          </div>

          <Modal
            isOpen={isEditModalOpen}
            toggle={() => setIsEditModalOpen(false)}
            centered size="lg"
          >
            <ModalHeader toggle={() => setIsEditModalOpen(false)}>
              Edit Directory
            </ModalHeader>
            <ModalBody>


              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Location
                    <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                  </label>
                  <select
                    className="form-select"
                    value={currentImages?.location || ""}
                    onChange={(e) =>
                      setCurrentImages((prev) => ({
                        ...prev,
                        location: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select Location</option>
                    {locations.map((loc, index) => (
                      <option key={index} value={loc}>
                        {loc}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="col-md-6">
                <label className="form-label">
                  Designation
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <select
                  className="form-select"
                  value={currentImages?.designation || ""}
                 
                  onChange={(e) =>
                    setCurrentImages((prev) => ({
                      ...prev,
                      designation: e.target.value,
                    }))
                  }
                >
                  <option value="">Select Location</option>
                  {designation.map((loc, index) => (
                    <option key={index} value={loc.value}>
                      {loc.name}
                    </option>
                  ))}
                </select>
              </div> */}
                <div className="col-md-6 mt-4">
                  <label className="form-label">
                    Name of Employee
                    <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={currentImages?.name}
                    onChange={(e) =>
                      setCurrentImages((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                    placeholder="Enter Name"
                  />
                </div>
                <div className="col-md-6 mt-4">
                  <label className="form-label">
                    Address of Employee
                    <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={currentImages?.address}
                    onChange={(e) =>
                      setCurrentImages((prev) => ({
                        ...prev,
                        address: e.target.value,
                      }))
                    }
                    placeholder="Enter Address"
                  />
                </div>
                <div className="col-md-6 mt-4">
                  <label className="form-label">
                    Mobile Number(R)
                    <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="mobileNo"
                    value={currentImages?.mobileNo}
                    onChange={(e) =>
                      setCurrentImages((prev) => ({
                        ...prev,
                        mobileNo: e.target.value,
                      }))
                    }
                    placeholder="Enter Mobile Number"
                  />
                </div>
                <div className="col-md-6 mt-4">
                  <label className="form-label">
                    Contact Number(O)

                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="officeNo"
                    value={currentImages?.officeNo}
                    onChange={(e) =>
                      setCurrentImages((prev) => ({
                        ...prev,
                        officeNo: e.target.value,
                      }))
                    }
                    placeholder="Enter Contact Number"
                  />
                </div>
                <div className="col-md-6 mt-4">
                  <label className="form-label">
                    Email<span style={{ color: "red", fontSize: "1rem" }}>*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={currentImages?.email}
                    onChange={(e) =>
                      setCurrentImages((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                    placeholder="Enter Number"
                  />
                </div>

                <div className="col-md-6 mt-4">
                  <label className="form-label">Upload Image<span style={{ color: "red", fontSize: "1rem" }}>*</span></label>
                  <input
                    type="file"
                    className="form-control"
                    ref={fileInputRef}
                  />
                </div>

              </div>

            </ModalBody>
            <ModalFooter className="flex-nowrap">
              <Button color="success" onClick={handleEditSave}>
                Save Changes
              </Button>
              <Button
                color="secondary"
                onClick={() => setIsEditModalOpen(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
    </>
  );
};

export default Links;
